module.exports = __webpack_public_path__ + "img/alexander.02070330.jpg";